import personImg1 from "./../assets/images/png/personImg1.png";
import personImg2 from "./../assets/images/png/personImg2.png";
import personImg3 from "./../assets/images/png/personImg3.png";
import personImg4 from "./../assets/images/png/personImg4.png";
import personImg5 from "./../assets/images/png/personImg5.png";

export const portfolioTabsData = [
  {
    show: "Financial Assets",
    value: "financial",
  },
  {
    show: "Liabilities",
    value: "liabilities",
  },
  {
    show: "Derivatives",
    value: "derivatives",
  },
  {
    show: "Real Estate",
    value: "realEstate",
  },
];

export const portfolioTabsWithOffshore = [
  ...portfolioTabsData,
  {
    show: "Global",
    value: "global",
  },
];

export const derivativeFixTab = ["FY-1", "FY-2", "FY-3"];

export const derivativeTabs = ["ITD", "YTD", "FY-1", "FY-2", "FY-3"];

export const analyticsTabsData = ["Overall", "Equity", "Fixed Income"];

export const performanceFilterTransaction = [
  { value: "Both", id: 0 },
  { value: "Stocks", id: 1 },
  { value: "Index", id: 2 },
];
export const performanceFilterOptions = [
  { value: "Both", id: 0 },
  { value: "Call", id: 1 },
  { value: "Put", id: 2 },
];
export const datesData = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];
export const monthData = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const monthsNum = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

export const monthsNum2 = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
];

export const monthsData3 = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const newMonthData = {
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  10: "October",
  11: "November",
  12: "December",
};

export const datesStrings = {
  "01": "1",
  "02": "2",
  "03": "3",
  "04": "4",
  "05": "5",
  "06": "6",
  "07": "7",
  "08": "8",
  "09": "9",
  10: "10",
  11: "11",
  12: "12",
  13: "13",
  14: "14",
  15: "15",
  16: "16",
  17: "17",
  18: "18",
  19: "19",
  20: "20",
  21: "21",
  22: "22",
  23: "23",
  24: "24",
  25: "25",
  26: "26",
  27: "27",
  28: "28",
  29: "29",
  30: "30",
  31: "31",
};

export const getImageSrc = (number) => {
  switch (number) {
    case 0:
      return personImg1;
    case 1:
      return personImg2;
    case 2:
      return personImg3;
    case 3:
      return personImg4;
    case 4:
      return personImg5;
    default:
      return personImg1;
  }
};
